import _isEqual from "lodash/isEqual";
import _cloneDeep from "lodash/cloneDeep";
import { formatDate2ToText } from "@/scripts"

export class MessageParent {
  constructor() {
    this.list = []
  }

  add(item) {
    this.list.push(Message.build(item))
  }

  update(item) {
    const index = this.list.findIndex(el => el.id === item.id)
    index >=0 && this.list.splice(index, 1, Message.build(item))
  }

  remove(item) {
    const index = this.list.findIndex(el => _isEqual(_cloneDeep(el), _cloneDeep(item)) || el.id === item.id)
    index >=0 && this.list.splice(index, 1)
  }

  getForAPI() {
    return this.list.map(el => el.getForAPI())
  }

  build(obj) {
    if (obj) {
      this.list = obj.map(el => Message.build(el))
    }
    return this
  }
}

export class Message {
  constructor() {
    this.id = null
    this.author = null
    this.theme = null
    this.text = null
    this.speciality = null
    this.courseNumber = null
    this.applicationType = null
    this.messageFormat = null
    this.messageType = null
    this.messageStatus = null
    this.createDateTime = null
    this.sendDateTime = null
    this.addressee = null
  }

  get createDateTimeText() {
    return this.createDateTime ? formatDate2ToText(this.createDateTime) : ''
  }

  get sendDateTimeText() {
    return this.sendDateTime ? formatDate2ToText(this.sendDateTime) : ''
  }

  getForAPI() {
    return {
      id: this.id,
      author: this.author,
      theme: this.theme,
      text: this.text,
      speciality: this.speciality,
      courseNumber: this.courseNumber,
      applicationType: this.applicationType,
      messageFormat: this.messageFormat,
      messageType: this.messageType,
      messageStatus: this.messageStatus,
      createDateTime: this.createDateTime,
      sendDateTime: this.sendDateTime,
      addressee: this.addressee,
    }
  }

  static build(obj) {
    const _this = new Message()
    if (obj) {
      _this.id = obj.id
      _this.author = obj.author
      _this.theme = obj.theme
      _this.text = obj.text
      _this.speciality = obj.speciality
      _this.courseNumber = obj.courseNumber
      _this.applicationType = obj.applicationType
      _this.messageFormat = obj.messageFormat
      _this.messageType = obj.messageType
      _this.messageStatus = obj.messageStatus
      _this.createDateTime = obj.createDateTime
      _this.sendDateTime = obj.sendDateTime
      _this.addressee = obj.addressee
    }
    return _this
  }
}

export class MessageFilter {
  constructor(messageType = null) {
    this.applicationType = null
    this.author = null
    this.courseNumber = null
    this.messageStatus = {id: 1, name: 'Черновик'}
    this.messageType = messageType
    this.speciality = null
    this.theme = null
  }
}

export class MessageRequestDto {
  constructor() {
    this.message = new Message()

    this.specialities = []
    this.types = []
    this.courseNumbers = []

    this.text = null
    this.theme = null

    this.application = null
  }

  static buildMass(obj) {
    if (obj) return {
      message: Message.build(obj),

      courseNumbers: obj.courseNumber,
      specialities: obj.speciality,
      types: obj.applicationType,
      text: obj.text,
      theme: obj.theme
    }
  }

  static buildIndividual(obj) {
    if (obj) {
      return {
        message: Message.build(obj),

        application: obj?.addressee?.length ? obj?.addressee[0] : null,
        text: obj.text,
        theme: obj.theme
      }
    }
  }

  forApi() {
    return {
      specialities: this.specialities,
      courseNumbers: this.courseNumbers,
      types: this.types,
    }
  }
}
